import React from 'react';
import { useStaticQuery, graphql, Link } from 'gatsby';
import resolveUrl from '../../../utils/urls/resolve-url';
import * as b from "../../bootstrap.module.css";
import Icon from "../../icon.tsx";

const PaydayLoanContents = ({ active }) => {
  const { ranking, articles } = useStaticQuery(graphql`
    query PaydayLoanContents {
      ranking: mysqlRanking(mysqlId: {eq: 113}) {
        url
        prefix_url
      }

      articles: allMysqlBlog(
        filter: {blogTerms: {elemMatch: {term: {eq: "menu-chwilowka"}}}},
        limit: 4
      ) {
        nodes {
          title
          terms_path
          term_normalized
          url
          thumbnail_canvas
        }
      }
    }
  `);

  return (<>
    {ranking && (<>
      <strong>Rankingi</strong>

      <Link 
        to={resolveUrl(ranking.prefix_url, ranking.url)} 
        className={["top-navigation-link", "gold", b.mt2, b.mb4].join(' ')}
      >
        {active && <span className="top-navigation-link-icon">
          <Icon icon="Ranking" size={34} />
        </span>}

        Ranking najlepszych chwilówek
      </Link>
    </>)}

    {active && articles.nodes.length > 0 && (<>
      <strong>Artykuły o chwilówkach</strong>

      <div className={['top-navigation-posts', b.mt2, b.pt1].join(' ')}>
        {articles.nodes.map((article, i) => (
          <Link key={i} to={resolveUrl(article.terms_path, article.term_normalized, article.url)}>
            <img src={article.thumbnail_canvas?.replace('/fa/', '/fk/')} className="top-navigation-thumbnail" loading="lazy" alt="" />
            
            <strong>{article.title}</strong>
          </Link>
        ))}
      </div>  
    </>)} 
  </>);
};

export default PaydayLoanContents;
